<template>
  <div class="pixi-image" v-pixi="canAnimate"></div>
</template>

<script>
import anime from 'animejs'
import * as pixiSetup from './pixi-setup.js'

export default {
  name: 'PixiImage',
  data: () => ({
    app: undefined,
    imageSprite: undefined,
    filterSprite: undefined,
    displacementFilter: undefined // Memorizza il displacement filter
  }),
  props: {
    image: {
      required: true
    },
    filter: {
      required: true
    },
    canAnimate: {
      type: Boolean,
      default: false
    },
    sizes: {
      type: Array,
      default: () => [1920, 2500]
    }
  },
  directives: {
    'pixi': {
      async bind (el, binding, vnode) {
        // Carica l'immagine principale
        vnode.context.imageSprite = pixiSetup.loadSprite(vnode.context.image, {
          width: vnode.context.sizes[0],
          height: vnode.context.sizes[1]
        })
        // Carica il filtro displacement
        vnode.context.filterSprite = pixiSetup.loadSprite(vnode.context.filter, {
          anchor: 0.5,
          x: vnode.context.sizes[0] / 2,
          y: vnode.context.sizes[1] / 2,
          width: vnode.context.sizes[0],
          height: vnode.context.sizes[1],
          scaleX: 1, // Valori iniziali
          scaleY: 1
        })

        // Imposta il filtro displacement
        vnode.context.displacementFilter = pixiSetup.setupFilter(vnode.context.filterSprite)

        // Configura l'app Pixi
        vnode.context.app = pixiSetup.setupApp(el,
          vnode.context.sizes,
          [vnode.context.displacementFilter],  // Aggiungi il filtro displacement
          vnode.context.imageSprite,
          vnode.context.filterSprite)

        vnode.context.app.stop()
        anime.set(el, { opacity: 0 })
      },
      update (el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
          vnode.context.app.start()

          // Anima il filtro displacement e rendilo più visibile
          const tl = anime.timeline({
            complete: () => {
              vnode.context.app.stage.filters = null
              vnode.context.app.stop()
            }
          })
          tl
            .add({
              targets: el,
              opacity: 1,
              easing: 'linear',
              duration: 3000
            })
            .add({
              targets: vnode.context.displacementFilter.scale,
              x: 0,  // Aumenta la scala per rendere l'effetto più visibile
              y: 0,
              easing: 'easeInOutQuad', // Cambia il tipo di easing per rendere l'animazione più fluida
              duration: 3000
            }, '-=3000') // Sovrapponi l'animazione del filtro con quella dell'opacità
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
